<ndt-allowed-ip-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [isLoading]="isLoading$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   (create)="onCreate()"
   [name]="entityName"
   [columns]="columns"
   [bannedallowedIpPrivileges]="bannedallowedIpPrivileges$ | async"
   (loadMore)="onLoadMore()"
   (quickFilterChange)="onQuickFilterChange($event)"
   (deleteAllowedIp)="onDeleteAllowedIp($event)"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   [orderingOptions]="orderingOptions$ | async"
   (edit)="onEdit($event)"
></ndt-allowed-ip-register-view>
